import { Modal, Button, Input, Label, FormGroup } from 'reactstrap';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import { GET_TEAMS } from 'graphql/queries';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { ASSIGN_TEMPLATE } from 'graphql/mutations';
import useNotificationAlert from 'hooks/useNotificationAlert';

const ModalAssignTemplate = ({ isShow, onClose, survey }) => {
  const { me } = useSelector((state) => state.auth);

  const [values, setValues] = useState([]);

  const [value, setValue] = useState('all');

  useEffect(() => {
    if (survey.assignTemplateType) {
      setValue(survey.assignTemplateType);
    }
  }, [survey]);

  const [callGetTeams, { loading: isLoadingData, data: dataTeams }] = useLazyQuery(GET_TEAMS, {
    variables: { first: 200 }
  });

  const { show: showNotificationAlert } = useNotificationAlert({
    place: 'br'
  });

  const [assignTemplate, { loading: isLoadingAssign }] = useMutation(ASSIGN_TEMPLATE);

  const onAssignTemplate = async () => {
    try {
      await assignTemplate({
        variables: {
          surveyId: survey.id,
          teams: values.map((elm) => elm.id),
          assignTemplateType: value
        }
      });

      showNotificationAlert({
        title: 'Success',
        message: 'You have updated the survey successfully!'
      });

      onClose();
    } catch (error) {
      console.log('Error', error);
    }
  };

  useEffect(() => {
    if (me.isTemplateCreationAdmin) {
      callGetTeams();
    }
  }, [me, callGetTeams]);

  useEffect(() => {
    if (survey.surveyTemplateTeams) {
      setValues(
        survey.surveyTemplateTeams.map((elm) => {
          const id = elm.id;

          return {
            id,
            name: (dataTeams?.getTeams.data || []).find((elm) => elm.id === id)?.name
          };
        })
      );
    }
  }, [survey, dataTeams]);

  const isDisabled = (value === 'any' && values.length <= 0) || isLoadingAssign;

  return (
    <Modal className="modal-dialog-centered" isOpen={isShow} toggle={onClose} keyboard={false}>
      <div className="modal-header justify-content-center">
        <h6 className="modal-title">Assign Template</h6>
      </div>
      <div className="modal-body">
        <div>
          <FormGroup check className="mb-1">
            <Input
              name="select_clients"
              type="radio"
              id="select-all"
              checked={value === 'all'}
              onChange={(e) => setValue(e.target.value)}
              value="all"
            />
            <Label check htmlFor="select-all">
              All Clients
            </Label>
          </FormGroup>

          <FormGroup check>
            <Input
              name="select_clients"
              type="radio"
              id="select-any"
              checked={value === 'any'}
              onChange={(e) => setValue(e.target.value)}
              value="any"
            />
            <Label check htmlFor="select-any">
              Selected Clients
            </Label>
          </FormGroup>

          {value === 'any' && (
            <>
              {isLoadingData ? (
                <p>Loading...</p>
              ) : (
                <Select
                  className="mt-2"
                  options={dataTeams.getTeams.data || []}
                  isMulti
                  getOptionLabel={(elm) => elm.name}
                  getOptionValue={(elm) => elm.id}
                  value={values}
                  onChange={(data) => {
                    setValues(data);
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <Button
          type="button"
          color="primary"
          className="rounded-pill"
          onClick={onAssignTemplate}
          disabled={isDisabled}>
          {isLoadingAssign ? 'Loading...' : 'Assign Template'}
        </Button>
      </div>
    </Modal>
  );
};

export default ModalAssignTemplate;
